<template>
  <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
    <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
      <div v-bind:class="wrapperClass" style="height:100%;position:relative;width:100%">
        <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
          <img v-bind:src="imgValue" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      imgValue: "",
      wrapperClass: ""
    }
  },
  mounted: function () {
    /**
      i don't remember why but it tooks some wrangling to get the
      wistia player loaded with dynamic attributes.
      rp - 7/1/19
    **/

    const script1 = document.createElement('script')
    const script2 = document.createElement('script')

    // Set player dynamic vars by video id
    this.imgValue = "https://fast.wistia.com/embed/medias/" + this.$store.state.completionStepForModal.videoId + "/swatch"
    this.wrapperClass = "wistia_embed wistia_async_" + this.$store.state.completionStepForModal.videoId + " videoFoam=true"

    script1.src = this.$store.state.completionStepForModal.url
    script1.async = true

    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js'
    script2.async = true

    document.body.appendChild(script1)
    document.body.appendChild(script2)
  }
}
</script>
<style scoped>
  .v--modal-overlay {
    background: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/HistoryVideoView.vue